import { ajaxPostJson } from './ajax';
import url from './url';
//获取权限作业菜单信息
export const queryUserRoleResourceAjax = (params) => {
  // 菜单版本控制
  return ajaxPostJson(`${url.queryUserRoleResource}`, params);
};

// 获取导航信息
export const navInfoAjax = (params) => {
  // 菜单版本控制
  params.version = MENU_VERSION;
  return ajaxPostJson(`${url.RESOURCE}`, params);
};


//切换团队公司
export const changeCompayAjax = (params) => {
  return ajaxPostJson(`${url.CHANGECOMPANY}`, params);
};

//获取最高权限
export const rootLevelAjax = (params) => {
  return ajaxPostJson(`${url.GETROOT}`, params);
};

// 上传
export const upload = (url, params, config) => {
  return ajaxPostJson(url, params, 'BaseApi5', 1, config);
};

// 创建自定义领域
export const addCustomDomain = (params) => {
  params.dataType = 'trans_domain';
  return ajaxPostJson(`${url.ADDCUSTOMDOMAIN}`, params);
};

